import React, { useCallback, useState } from 'react';
import Avatar from '@atlaskit/avatar';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { useIntl } from '@atlassian/jira-intl';
import { ConditionalTooltip } from '@atlassian/jira-jql-builder-common/src/ui/conditional-tooltip/index.tsx';
import { ScreenReaderText } from '@atlassian/jira-accessibility/src/common/ui/screenreader-text/index.tsx';
import type { AvatarOption } from '../../../common/types.tsx';
import {
	StyledLabel,
	StyledLabelIcon,
	StyledLabelText,
	StyledOption,
	StylesGroupIconContainer,
} from '../../../common/ui/styled.tsx';
import messages from './messages.tsx';

type Props = {
	data: AvatarOption;
};

export const AvatarOptionLabel = ({ data }: Props): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const [labelOverflows, setLabelOverflows] = useState(false);

	const onLabelRef = useCallback((node: HTMLDivElement) => {
		if (node != null) {
			setLabelOverflows(node.offsetWidth < node.scrollWidth);
		}
	}, []);

	return (
		<ConditionalTooltip condition={labelOverflows} content={data.label} position="right">
			<StyledOption>
				<StyledLabel>
					{data.hideAvatar !== true && (
						<StyledLabelIcon>
							{data.isGroup === true ? (
								<StylesGroupIconContainer>
									<PeopleGroupIcon
										testId="jql-builder-basic-picker.ui.format-option-label.avatar-option-label.group-icon"
										label={formatMessage(messages.groupIcon)}
									/>
								</StylesGroupIconContainer>
							) : (
								<Avatar
									src={typeof data.avatar !== 'string' ? undefined : data.avatar}
									size="xsmall"
									testId="jql-builder-basic-picker.ui.format-option-label.avatar-option-label.avatar"
									appearance={
										typeof data.square === 'boolean' && data.square === true ? 'square' : 'circle'
									}
								/>
							)}
						</StyledLabelIcon>
					)}
					<StyledLabelText ref={onLabelRef}>{data.label}</StyledLabelText>
				</StyledLabel>
				{data.disabledMessage && <ScreenReaderText>{data.disabledMessage}</ScreenReaderText>}
			</StyledOption>
		</ConditionalTooltip>
	);
};
export default AvatarOptionLabel;
